import {roomService} from "../network/services/room.service";
import {IF_BAR_THEN_ONLY_BAR} from "../helpers/config";

export default {
    namespaced: true,
    state: {
        loading: false,
        apiResult: null
    },
    getters: {
        isFiltered: (state, getters, rootState, rootGetters) => {
          const shoppingCartProvider = rootGetters["shoppingCart/currentProvider"];
          return shoppingCartProvider && shoppingCartProvider !== state.apiResult.provider;
        },
        prices: (state, getters, rootState) => {
            if (!state.apiResult) return [];
            const bookings = rootState.shoppingCart.bookings;
            const isInsurance = bookings.length > 0 ? bookings[0].room_price.is_insurance : null

            const prices = [];
            for (const pricePlan of state.apiResult.price_plans) {
                const date = pricePlan.date;
                for (const inputPrice of pricePlan.input_prices) {
                    for (const edge of inputPrice.edges) {
                        let index = prices.map(p => p.id).indexOf(edge.from.id);
                        if (index === -1) {
                            prices.push(edge.from);
                            index = prices.length - 1;
                        }
                        if (!prices[index].input) prices[index].input = [];
                        if (!prices[index].altPrice) prices[index].altPrice = [];
                        edge.date = date;
                        prices[index].input.push(edge);
                        if (edge.altPrice && prices[index].altPrice && typeof prices[index].altPrice.push === 'function') {
                            prices[index].altPrice.push(edge.altPrice);
                        }
                    }
                }
            }
            return prices;
        },
        priceTotal: (state, getters) => {
            return getters.prices.slice().map(price => {
                price.total = price.input.reduce((prev, curr) => {
                    if (prev === null) return curr;
                    for (const key of Object.keys(prev)) {
                        if (typeof prev[key] === 'number')
                            prev[key] += curr[key];
                    }
                    return prev;
                }, null);
                if (price.altPrice) {
                    price.altPrice = [price.altPrice].reduce((prev, curr) => {
                        if (prev === null) return curr;
                        for (const key of Object.keys(prev)) {
                            if (typeof prev[key] === 'number')
                                prev[key] += curr[key];
                        }
                        return prev;
                    }, null);
                }

                return price
            })
        }
    },
    mutations: {
        SET_API_RESULT (state, payload) {
            state.apiResult = payload;
        },
        SET_LOADING (state, payload) {
            state.loading = !!payload;
        }
    },
    actions: {
        async query(context, args) {
            if (args.start && args.end) {
                const dates = [];
                let tmp = args.start.isBefore(args.end) ? args.start : args.end;
                const days = Math.abs(args.start.diff(args.end, 'days'));
                for (let i = 0; i < days; i++) {
                    dates.push(tmp.clone().add(i, 'd').format('YYYY-MM-DD'));
                }
                delete args.start;
                delete args.end;
                args.dates = dates;
            }
            context.commit('SET_LOADING', true);
            context.commit('SET_API_RESULT', null);
            const token = context.rootState.client.tokens.accessToken;
            const response = await roomService.queryPrices(args, token);
            context.commit('SET_API_RESULT', response.get('Room.one'))
            context.commit('SET_LOADING', false);
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/resa-picker.store.js